module.exports = __webpack_public_path__ + "static/pinkbunny-00d703dcd816409de5857563301717c5.png";